import { Form, Spin, Tabs } from "antd"
import type React from "react"
import { useEffect, useState } from "react"
import DF from "DisplayFramework"
import DemandSubTab from "./DemandSubTab"
import ContractSubTab from "./ContractSubTab"
import GetLabel from "DisplayFramework/components/GetLabel"
import ReservationAnomalyTab from "./ReservationAnomalyTab"
import ReservationSubTab from "./ReservationSubTab"
import BulkUploadTab from "./BulkUploadTab" // Import du nouveau composant
import { useForm } from "antd/lib/form/Form"
import ConActivityAnomalyTab from "./ConActivityAnomalyTab"

const ConActivityTab: React.FC = () => {
  const [form] = useForm()
  const tptype = "CONC"
  const [color, setColor] = useState<string>()
  const [activeTabKey, setActiveTabKey] = useState<string>("1") // Track active tab

  useEffect(() => {
    if (tptype === "CONC") {
      setColor("green")
    } else if (tptype === "PM") {
      setColor("duck-blue")
    } else if (tptype === "SPM") {
      setColor("blue")
    }
  }, [tptype])

  // Handle tab change
  const handleTabChange = (key: string) => {
    setActiveTabKey(key)
  }

  // Callback for when a tab is activated
  const handleTabActivated = (tabKey: string) => {
    console.log(`Tab ${tabKey} activated and data refreshed`)
  }

  return (
    <DF.Provider pagcode="contractactivity">
      <Spin spinning={false}>
        <Form layout="vertical" form={form}>
          <Tabs className="tabs-border-top" activeKey={activeTabKey} onChange={handleTabChange}>
            <Tabs.TabPane forceRender tab={<GetLabel label="outstandings" className="font-size-15" />} key="1">
              <ContractSubTab
                form={form}
                tpauthid={0}
                itemsCompanyHierarchyTree={[]}
                isActive={activeTabKey === "1"}
                onTabActivated={() => handleTabActivated("1")}
              />
            </Tabs.TabPane>
            
            <Tabs.TabPane forceRender tab={<GetLabel label="reservationstab" className="font-size-15"/>} key="2">
              <ReservationSubTab
                form={form}
                tpauthid={0}
                itemsCompanyHierarchyTree={[]}
                isActive={activeTabKey === "2"}
                onTabActivated={() => handleTabActivated("2")}
              />
            </Tabs.TabPane>
            
            <Tabs.TabPane forceRender tab={<GetLabel label="demands" className="font-size-15"/>} key="3">
              <DemandSubTab
                form={form}
                itemsCompanyHierarchyTree={[]}
                isActive={activeTabKey === "3"}
                onTabActivated={() => handleTabActivated("3")}
              />
            </Tabs.TabPane>
            
            {tptype === "CONC" && (
              <Tabs.TabPane forceRender tab={<GetLabel label="Incidents" className="font-size-15"/>} key="4">
                <ConActivityAnomalyTab
                  form={form}
                  tpauthid={0}
                  itemsCompanyHierarchyTree={[]}
                  isActive={activeTabKey === "4"}
                  onTabActivated={() => handleTabActivated("4")}
                />
              </Tabs.TabPane>
            )}
            
            {/* Nouveau Tab pour le chargement en masse */}
            <Tabs.TabPane 
              forceRender 
              tab={<GetLabel label="Chargement en masse" className="font-size-15"/>} 
              key="5"
            >
              <BulkUploadTab
                form={form}
                tpauthid={0}
                itemsCompanyHierarchyTree={[]}
                isActive={activeTabKey === "5"}
                onTabActivated={() => handleTabActivated("5")}
              />
            </Tabs.TabPane>
          </Tabs>
        </Form>
      </Spin>
    </DF.Provider>
  )
}

export default ConActivityTab